<template>
  <div
    v-if="showProgress"
    class="free-gift"
  >
    <progress-bar
      :percentage="progressBarValue"
      :progress-text="progressBarText"
    />
    <line-item
      v-if="product"
      block-class="free-gift"
      is-free-gift
      :free-gift-target="target"
      :item="product"
    />
  </div>
</template>

<script>

/**
 * Vue: Free gift (free-gift)
 * -----------------------------------------------------------------------------
 * Discount ninja free gift promotion.
 *
 */
import { mapState } from 'vuex'
import ProgressBar from '~async/progress-bar/progress-bar'
import LineItem from '~async/line-item/line-item'

export default {
  name: 'FreeGift',

  components: { ProgressBar, LineItem },

  props: {
    isCartDrawer: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      product: {},
      target: 0,
      showProgress: false,
    }
  },

  computed: {

    /**
   * Map Vuex state.
   */
    ...mapState({
      cart: (state) => state.cart.response,
    }),

    /**
     * Is free shipping threshold met.
     * @returns {boolean}
     */
    cartThresholdMet() {
      return this.cart?.total_price >= this.target
    },

    /**
     * Gets the remaining number for the free shipping threshold.
     * @returns {number}
     */
    freeDeliveryRemainingValue() {
      return this.target - this.cart?.total_price
    },

    /**
     * Gets the percentage value to meet free shipping threshold.
     * @returns {number}
     */
    progressBarValue() {
      if (this.cartThresholdMet) {
        return 100
      }

      // eslint-disable-next-line no-mixed-operators
      return 100 - ((
        this.target - this.cart?.total_price
      // eslint-disable-next-line no-mixed-operators
      ) * 100) / this.target
    },

    /**
     * Decide which text will be shown on free shipping progress bar.
     * @returns {string}
     */
    progressBarText() {
      return this.cartThresholdMet
        ? this.$string('cart.free_gift.success')
        : this.$string('cart.free_gift.spend_more', {
          replace: {
            value: this.$formatMoney(this.freeDeliveryRemainingValue),
          },
        })
    },
  },

  mounted() {
    if (this.isCartDrawer) {
      this.discountNinjaEventListener()
      this.discountNinja()

      return
    }

    this.discountNinjaEventListener()
  },

  methods: {
    discountNinjaEventListener() {
      document.addEventListener('limoniapps:discountninja:promotions:loaded', () => {
        this.discountNinja()
      })
    },

    discountNinja() {
      if (window.discountNinja && window.discountNinja?.Offer?.AllOffers.length > 0) {
        const freeGiftPromotion = window.discountNinja?.Offer?.AllOffers?.find(offer => offer.OfferType === 'bogo') || {}
        const freeProductHandle = freeGiftPromotion?.Entitlement?.EntitledProductHandles || ''
        this.target = freeGiftPromotion.Tiers[0].Prerequisite.MinimumAmountBaseCurrency * 100

        fetch(`${window.Shopify.routes.root}products/${freeProductHandle}.json`)
          .then((response) => response.json())
          .then((data) => {
            this.product = data.product
          })

        this.showProgress = true
      }
    },
  },
}
</script>

<style lang="scss">
@import './free-gift';
</style>
